import { useState, type FormEvent } from 'react'

import { confirmPasswordReset } from '../../api/auth'
import { AuthShell } from './AuthShell'

type ResetPasswordScreenProps = {
  token: string
  onBack: () => void
  /** Успешный сброс → вернуться ко входу. */
  onDone: () => void
}

export const ResetPasswordScreen = ({ token, onBack, onDone }: ResetPasswordScreenProps) => {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError(null)
    setMessage(null)
    if (!token) {
      setError('Ссылка для сброса пароля недействительна или устарела')
      return
    }
    if (password.length < 8) {
      setError('Пароль должен быть не короче 8 символов')
      return
    }
    if (password !== confirm) {
      setError('Пароли не совпадают')
      return
    }
    setLoading(true)
    try {
      const response = await confirmPasswordReset(token, password)
      setMessage(response.message || 'Пароль обновлён. Теперь можно войти.')
      window.setTimeout(onDone, 1200)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось обновить пароль')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell
      title="Новый пароль"
      subtitle="Задайте пароль для входа в Провизиум"
      onBack={onBack}
    >
      {!token ? (
        <p className="echat-error" role="alert">
          Ссылка для сброса пароля недействительна или устарела. Запросите новую.
        </p>
      ) : (
        <form className="pwa-auth__form" onSubmit={handleSubmit}>
          <label className="echat-field">
            <span className="echat-field__label">Новый пароль</span>
            <input
              className="echat-field__input"
              type="password"
              autoComplete="new-password"
              required
              minLength={8}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
          <label className="echat-field">
            <span className="echat-field__label">Повторите пароль</span>
            <input
              className="echat-field__input"
              type="password"
              autoComplete="new-password"
              required
              minLength={8}
              value={confirm}
              onChange={(event) => setConfirm(event.target.value)}
            />
          </label>

          {message ? <p className="pwa-auth__message" role="status">{message}</p> : null}
          {error ? (
            <p className="echat-error" role="alert">
              {error}
            </p>
          ) : null}

          <button type="submit" className="echat-btn echat-btn--primary" disabled={loading}>
            {loading ? 'Сохранение…' : 'Сохранить пароль'}
          </button>
        </form>
      )}

      <div className="pwa-auth__links pwa-auth__links--center">
        <button type="button" className="pwa-auth__link" onClick={onBack}>
          ← Вернуться ко входу
        </button>
      </div>
    </AuthShell>
  )
}
